module.exports = __WEBPACK_EXTERNAL_MODULE_11__;


//////////////////
// WEBPACK FOOTER
// external {"root":["AWSCognito","CognitoIdentityServiceProvider"],"commonjs2":"aws-sdk/clients/cognitoidentityserviceprovider","commonjs":"aws-sdk/clients/cognitoidentityserviceprovider","amd":"aws-sdk/clients/cognitoidentityserviceprovider"}
// module id = 11
// module chunks = 0